import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTransactionTypePlusIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 19,
	viewBox: "0 0 18 19",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M9 3.70221V15.7022",
		stroke: "black",
		strokeWidth: 1.3,
		strokeLinecap: "square"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M15 9.70221L3 9.70221",
		stroke: "black",
		strokeWidth: 1.3,
		strokeLinecap: "square"
	})]
});
export default SvgTransactionTypePlusIcon;
